<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>

            <b-breadcrumb-item
              :to="{
                name: 'OrganizationHome',
              }"
              >組織資料設定</b-breadcrumb-item
            >
            <b-breadcrumb-item
              :to="{
                name: 'OrganizationVariableList',
              }"
              >組織參數管理</b-breadcrumb-item
            >
            <b-breadcrumb-item active>新增</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-form>
      <b-overlay>
        <b-card :title="title">
          <b-card-body>
            <organization-variable-form :validationErrors="validationErrors" :organizationVariable="organizationVariable"></organization-variable-form>

            <b-button class="mr-3" @click="goListPage()" variant="outline-danger">返回</b-button>
            <b-button @click="submit" variant="success">儲存</b-button>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-form>
  </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import OrganizationVariableForm from './OrganizationVariableForm'
import organizationVariableApi from "@/apis/organization-variable";
import merchantApi from "@/apis/merchant";

export default {
  components: { OrganizationVariableForm },
  data () {
    return {
      validationErrors: null,
      organizationVariable: {
        key: null,
        value: null,
        type: null,
        merchant_id: this.$route.params.merchant_id,
      },
      merchantName: '',
    }
  },
  mounted() {
    if (this.$route.params.merchant_id) {
      this.getMerchant();
    }
  },
  computed: {
    ...mapState('general', {
      organization: state => state.organization,
    }),
    ...mapGetters('route', ['routeQuery', "routeParams"]),
    title() {
      const orgName = (this.organization && this.organization.name) || '';
      let displayContent = orgName;
      if (this.merchantName) {
        displayContent = `${orgName} - ${this.merchantName}`;
      }
      const displayTitle = displayContent ? `【${displayContent}】` : '';
      return `${displayTitle}新增組織參數`;
    },
  },
  methods: {
    async getMerchant() {
      try {
        const { data } = await merchantApi.getMerchant(this.organization.id, this.$route.params.merchant_id);
        this.merchantName = data.data.name;
      } catch (error) {
        console.error(error);
      }
    },
    async submit () {
      try {
        let response = await organizationVariableApi.store({
          org_code: this.organization.id,
          organizationVariable: this.organizationVariable,
        })

        if (response.status && response.status === 200) {
          this.$swal.fire({
            title: '新增成功',
            type: 'success'
          })
          this.goListPage()
        }
      } catch (error) {
        console.log(error)

        if (error.response.status === 422 && error.response.data.message) {
          this.validationErrors = error.response.data.message
        }
      }
    },
    goListPage() {
      if (this.$route.params.merchant_id) {
        this.$router.push({
          name: 'OrganizationVariableListByMerchant',
          params: { merchant_id: this.$route.params.merchant_id },
          query: this.routeQuery
        })
        return;
      }

      this.$router.push({name: 'OrganizationVariableList'}, {
        query: this.routeQuery
      })
    },
  }
}
</script>
